import BaseService from '../../base/base_service';
import IStructuredLoggingService, {
  IElasticEventData,
  IStructuredLogger
} from '../../../../common/interfaces/structured-logging-service-interface';
import ElasticLogger from "./elastic_logger";


export default class StructuredLoggingService extends BaseService implements IStructuredLoggingService {
    static CLASS = 'StructuredLoggingService';
    private _environment: string;
    private _storageUrl: string;
    private _reportClientHints:boolean;


    init(params) {
        super.init(params);
        this._storageUrl = params.storageUrl;
        this._environment = params.environment;
        this._reportClientHints = params.reportClientHints;
    }

    getLogger(eventData?: IElasticEventData): IStructuredLogger {
        return this._createElasticLogger(eventData || {});
    }

    getEnvironment(): string {
        return this._environment;
    }

    private _createElasticLogger(eventData: IElasticEventData): IStructuredLogger {
        return ElasticLogger.create({
            serviceFactory: this.serviceFactory,
            environment: this._environment,
            storageUrl: this._storageUrl,
            reportClientHints: this._reportClientHints,
            eventData: eventData
        });
    }
}
